// extracted by mini-css-extract-plugin
module.exports = {"main":"BenchPlayer_main__FD6b3","name":"BenchPlayer_name__1DN5I","goals":"BenchPlayer_goals__1-FRA"};